export function compareAlphabetically(a: string, b: string): number {
  return a.toLowerCase().localeCompare(b.toLowerCase());
}

export function addPossessiveSuffix(str: string): string {
  return str.endsWith("s") ? `${str}'` : `${str}'s`;
}
